// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/AuditHome/SpeedResult.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/AuditHome/SpeedResult.tsx");
  import.meta.hot.lastModified = "1732036225889.5142";
}
// REMIX HMR END

import { Fragment } from "react";
import { resultMapping } from "../DocTahedroidImage";
import Button from "~/components/Button";
import CoreWebVitals from "../CoreWebVitals/CoreWebVitals";
import InlineLighthouse from "../PageSpeedInsights/InlineLighthouse";
import { useSearchParams } from "@remix-run/react";
import { calculateAttributesPassing, getDisclaimer } from "../utils";
import AuditShare from "../AuditShare";
import Heading from "~/components/Heading";
export default function SpeedResult({
  psi,
  crux,
  reportId
}) {
  _s();
  const [searchParams, setSearchParams] = useSearchParams();
  const result = calculateAttributesPassing({
    psi,
    crux
  });
  const {
    speed: {
      title,
      message
    }
  } = resultMapping[result?.variant || "boost"];
  const disclaimer = getDisclaimer({
    psi,
    crux
  });
  return <Fragment>
      <Heading tag="h2">{title}</Heading>
      {crux && <CoreWebVitals pass={crux.pass} cls={crux.cls} inp={crux.inp} lcp={crux.lcp} />}
      {!crux && <div className="flex gap-8 mb-4 w-full">
          <InlineLighthouse psi={psi} />
        </div>}
      <p className="text-neutral-600 mb-4">{message}</p>
      {result?.variant == "approval" && <AuditShare reportId={reportId} reportKind="performance" />}
      <div className="flex gap-4 mb-4">
        <Button to={`/audit?${searchParams.toString()}`} variant="tertiary" className="block w-fit">
          Read complete report
        </Button>
        <Button variant="secondary" onClick={() => setSearchParams({}, {
        preventScrollReset: true
      })}>
          Try another URL
        </Button>
      </div>
      <p className="text-xs text-neutral-600">
        {disclaimer && <p className="text-xs text-neutral-600 mt-4">{disclaimer}</p>}
      </p>
    </Fragment>;
}
_s(SpeedResult, "/eCs5CB4FLGAVLeprHBYLwBGf/Q=", false, function () {
  return [useSearchParams];
});
_c = SpeedResult;
var _c;
$RefreshReg$(_c, "SpeedResult");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;